import { render, staticRenderFns } from "./SellingStrategy.vue?vue&type=template&id=fefc932c&scoped=true&"
import script from "./SellingStrategy.vue?vue&type=script&lang=js&"
export * from "./SellingStrategy.vue?vue&type=script&lang=js&"
import style0 from "./SellingStrategy.vue?vue&type=style&index=0&id=fefc932c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefc932c",
  null
  
)

export default component.exports